import { render, staticRenderFns } from "./PopupImageInfo.vue?vue&type=template&id=8458bc2a"
import script from "./PopupImageInfo.vue?vue&type=script&lang=js"
export * from "./PopupImageInfo.vue?vue&type=script&lang=js"
import style0 from "./PopupImageInfo.vue?vue&type=style&index=0&id=8458bc2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports